function fixWishlistBadge() {
  const badge = document.querySelector('span.wishlist-hero-items-count');
  const hc = document.querySelector('header-component');
  if (!badge || !hc) return;

  if (!badge.classList.contains('wishlist-hero-items-count-exists')) {
    badge.style.setProperty('display', 'none', 'important');
    return;
  }

  const fg = getComputedStyle(hc).getPropertyValue('--color-foreground').trim();
  const isLight = fg.includes('255 255 255') || fg === 'rgb(255, 255, 255)';
  const textColor = isLight ? 'rgb(0,0,0)' : 'rgb(255,255,255)';

  badge.style.setProperty('position', 'absolute', 'important');
  badge.style.setProperty('top', '5px', 'important');
  badge.style.setProperty('right', '-10px', 'important');
  badge.style.setProperty('bottom', 'auto', 'important');
  badge.style.setProperty('left', 'auto', 'important');
  badge.style.setProperty('background-color', fg, 'important');
  badge.style.setProperty('color', textColor, 'important');
  badge.style.setProperty('width', '20px', 'important');
  badge.style.setProperty('height', '20px', 'important');
  badge.style.setProperty('border-radius', '50%', 'important');
  badge.style.setProperty('font-size', '10px', 'important');
  badge.style.setProperty('display', 'flex', 'important');
  badge.style.setProperty('align-items', 'center', 'important');
  badge.style.setProperty('justify-content', 'center', 'important');
  badge.style.setProperty('padding', '0', 'important');
  badge.style.setProperty('line-height', '1', 'important');
  badge.style.setProperty('box-sizing', 'border-box', 'important');
}

// Esegui una volta al caricamento e osserva solo childList (no attributeFilter)
document.addEventListener('DOMContentLoaded', fixWishlistBadge);
setTimeout(fixWishlistBadge, 500);

const observer = new MutationObserver(fixWishlistBadge);
observer.observe(document.body, { childList: true, subtree: true });


